import { defineStore } from 'pinia'

export const useQuoteOrderStore = defineStore('quoteOrder', {
  state: () => ({
    orderDetails: {
      description: '',
      deliveryAddress: {},
      invoiceAddress: {},
      includeFiles: true,
      project: {
        id: 0,
        name: ''
      },
      reference: '',
      externalId: ''
    },
    orderErrors: []
  }),

  actions: {
    resetOrder() {
      this.orderDetails = {
        description: '',
        deliveryAddress: {},
        invoiceAddress: {},
        includeFiles: true,
        project: {
          id: 0,
          name: ''
        },
        reference: '',
        externalId: ''
      }
      this.orderErrors = []
    },
    addOrderError(error) {
      if (!this.orderErrors.includes(error)) {
        this.orderErrors.push(error)
      }
    },
    removeOrderError(error) {
      this.orderErrors = this.orderErrors.filter((e) => e !== error)
    },
    updateOrderDetails(spec, value) {
      this.orderDetails[spec] = value
    },
    updateProject(proj) {
      this.orderDetails.project.name = proj.name || ''
      this.orderDetails.project.id = proj.id || 0
    }
  }
})
